module.exports = __webpack_public_path__ + "img/zhuanpan2.94f63fa3.png";